import { render, staticRenderFns } from "./BaseCheckbox.vue?vue&type=template&id=349d7fde&scoped=true"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js"
import style0 from "./BaseCheckbox.vue?vue&type=style&index=0&id=349d7fde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349d7fde",
  null
  
)

export default component.exports